<div class="palette-root">
  <div class="palette-title">
    Entity fields
    <span class="count">({{ fields.length }})</span>
  </div>

  <div class="search">
    <input [value]="query()" (input)="setQuery(($any($event.target)).value)" placeholder="検索（fieldName / displayName）" />
  </div>

  <div class="list">
    @for (f of filtered(); track f.fieldName) {
      <button
        type="button"
        class="chip"
        draggable="true"
        (dragstart)="handleDragStart($event, f.fieldName)"
        (click)="handlePick(f.fieldName)"
        title="ドラッグしてキャンバスへ配置"
      >
        <div class="display">{{ f.displayName || '（表示名なし）' }}</div>
        <div class="key">{{ f.fieldName }}</div>
      </button>
    }
  </div>
</div>

